"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debouncer = void 0;
const interval_time_1 = require("./interval_time");
class Debouncer {
    constructor(debounceDuration, lastDebounced = undefined) {
        this.debounceDuration = debounceDuration;
        this.lastDebounced = lastDebounced;
    }
    static deserialize(serializedValue) {
        const parsed = JSON.parse(serializedValue);
        return new Debouncer(parsed.debounceDuration, new Date(parsed.lastDebounced));
    }
    /**
     * Calls debounce to see if the debounce has triggered and if it has then reset the timer again.
     */
    debounced() {
        const afterTimestamp = (0, interval_time_1.decreaseTimeByDelta)(new Date(), this.debounceDuration);
        if (this.lastDebounced == undefined ||
            this.lastDebounced.getTime() < afterTimestamp.getTime()) {
            this.reset();
            return true;
        }
        return false;
    }
    /*
     * Resets the state of debouncing such that the minimum duration would need to pass again before triggerring a
     * debounce.
     */
    reset() {
        this.lastDebounced = new Date();
    }
}
exports.Debouncer = Debouncer;
